import React from 'react';
import InfoTooltip from '../../../common/tooltip/info/index';
import i18next from 'i18next';

const ChangeExchangeRateButton = open => (
  <InfoTooltip info={i18next.t('changeExchangeRate')}>
    <button className="btn btn-xs btn-fill btn-success" onClick={open}>
      <i
        className="fa fa-money"
      />
    </button>
  </InfoTooltip>
);

export default ChangeExchangeRateButton;



// WEBPACK FOOTER //
// ./src/components/actions/exchange-rate/button/index.js